import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function DocsIcon(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 18 18" {...props}>
			<path
				d="M10.4276 2.57129V5.42843C10.4276 5.61787 10.5029 5.79955 10.6368 5.93351C10.7708 6.06746 10.9524 6.14272 11.1419 6.14272H13.999M10.4276 2.57129H5.4276C5.04871 2.57129 4.68535 2.7218 4.41744 2.98971C4.14953 3.25762 3.99902 3.62098 3.99902 3.99986V13.9999C3.99902 14.3787 4.14953 14.7421 4.41744 15.01C4.68535 15.2779 5.04871 15.4284 5.4276 15.4284H12.5705C12.9493 15.4284 13.3127 15.2779 13.5806 15.01C13.8485 14.7421 13.999 14.3787 13.999 13.9999V6.14272M10.4276 2.57129L13.999 6.14272M6.85617 6.857H7.57045M6.85617 9.71415H11.1419M6.85617 12.5713H11.1419"
				stroke="#5B5B5B"
				stroke-width="1.07143"
				stroke-linecap="round"
				stroke-linejoin="round"
				fill="none"
			/>
			<path
				d="M10.4276 2.57129V5.42843C10.4276 5.61787 10.5029 5.79955 10.6368 5.93351C10.7708 6.06746 10.9524 6.14272 11.1419 6.14272H13.999M10.4276 2.57129H5.4276C5.04871 2.57129 4.68535 2.7218 4.41744 2.98971C4.14953 3.25762 3.99902 3.62098 3.99902 3.99986V13.9999C3.99902 14.3787 4.14953 14.7421 4.41744 15.01C4.68535 15.2779 5.04871 15.4284 5.4276 15.4284H12.5705C12.9493 15.4284 13.3127 15.2779 13.5806 15.01C13.8485 14.7421 13.999 14.3787 13.999 13.9999V6.14272M10.4276 2.57129L13.999 6.14272M6.85617 6.857H7.57045M6.85617 9.71415H11.1419M6.85617 12.5713H11.1419"
				stroke="black"
				stroke-opacity="0.2"
				stroke-width="1.07143"
				stroke-linecap="round"
				stroke-linejoin="round"
				fill="none"
			/>
		</SvgIcon>
	);
}

export default DocsIcon;
